import React, { useEffect, useRef, useState } from "react";
import Header from "../component/Header";
import Footer from "../component/Footer";
import { Helmet } from "react-helmet";

const API_PDF_URL = process.env.REACT_APP_API_PDF_URL;
const BASE_URL = process.env.REACT_APP_BASE_URL;


const FinancialResults = () => {
  const pageid = 22; // Use your correct page id
  const [financialData, setFinancialData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFinancialData = async () => {
      try {
        const res = await fetch(`${BASE_URL}?pageid=${pageid}`);
        if (!res.ok) throw new Error(`HTTP error! ${res.status}`);
        const result = await res.json();

        if (!result.success || !Array.isArray(result.data)) {
          setFinancialData([]);
          setLoading(false);
          return;
        }

        // Group by year_name
        const grouped = {};
        result.data.forEach((item) => {
          const year = item.year_name;
          if (!grouped[year]) grouped[year] = { results: [], newsPapers: [] };

          const fileData = {
            label: item.pdf_name,
            file: item.upload_file_path,
          };

          if (item.results_news_paper === "1") {
            grouped[year].newsPapers.push(fileData);
          } else {
            grouped[year].results.push(fileData);
          }
        });

        // Convert to array sorted by year descending
        const finalData = Object.keys(grouped)
          .map((year) => ({ year, ...grouped[year] }))
          .sort((a, b) => b.year - a.year);

        setFinancialData(finalData);
      } catch (error) {
        console.error("Fetch failed:", error);
        setFinancialData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchFinancialData();
  }, []);

  return (
    <>
      <Helmet>
        <title>Financial Results | Nandan Denim Ltd.</title>
      </Helmet>
      <Header />

      {/* Hero Section */}
      <div className="relative w-full">
        <img
          src="./imgs/investors/investorfinancialresult.png"
          alt="Chiripal Group Banner"
          className="object-cover w-full h-full md:h-[70vh] lg:h-[80vh] xl:h-[88vh]"
        />
        <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center">
          <div className="px-4 sm:px-8 md:px-16 lg:px-32">
            <h1 className="text-yellow-400 text-3xl sm:text-5xl md:text-7xl font-montserrat font-bold text-left">
              Financial Results
            </h1>
          </div>
        </div>
      </div>

      {/* Financial Results Section */}
      <div className="py-12 px-4 font-signika text-justify max-w-7xl mx-auto">
        {loading ? (
          <p>Loading financial results...</p>
        ) : financialData.length === 0 ? (
          <p>No financial results found.</p>
        ) : (
          financialData.map((yearBlock, index) => (
            <div
              key={index}
              className={`grid ${yearBlock.newsPapers.length > 0 ? "md:grid-cols-2" : "grid-cols-1"
                } gap-10 border-b border-gray-300 pb-6 mb-8`}
            >
              {/* Results Section */}
              <div>
                <h2 className="text-xl font-extrabold text-[#0b3a6a] mb-2">
                  FOR THE YEAR {yearBlock.year}
                </h2>
                <ul className="list-disc pl-6 space-y-1 text-[#0b3a6a]">
                  {yearBlock.results.map((item, idx) => (
                    <li key={idx}>
                      <a
                        href={item.file ? `${API_PDF_URL}/${item.file}` : "#"} // ✅ set # if no file
                        target={item.file ? "_blank" : "_self"}
                        rel="noopener noreferrer"
                        className={`hover:underline ${item.file ? "text-blue-900" : "text-blue-900"}`}
                      >
                        {item.label}
                      </a>
                    </li>
                  ))}
                </ul>

              </div>

              {/* Newspaper Section */}
              {yearBlock.newsPapers.length > 0 && (
                <div>
                  <h2 className="text-xl font-extrabold text-[#0b3a6a] mb-2">
                    Results News Paper
                  </h2>
                  <ul className="list-disc pl-6 space-y-1 text-[#0b3a6a]">
                    {yearBlock.newsPapers.map((item, idx) => (
                      <li key={idx}>
                          <a
                            href={item.file ? `${API_PDF_URL}/${item.file}` : "#"} // ✅ set # if no file
                            target={item.file ? "_blank" : "_self"}
                            rel="noopener noreferrer"
                            className={`hover:underline ${item.file ? "text-blue-900" : "text-blue-900"}`}
                          >
                            {item.label}
                          </a>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          ))
        )}
      </div>
      <Footer />
    </>
  );
};

export default FinancialResults;
